const failMsgs = [
    "The universe whispers... and you weren't listening.",
    "Your psychic channel appears to be experiencing some static.",
    "Looks like your third eye needs new glasses.",
    "Cosmic connection: unsuccessful. Retry after recalibrating your intuition.",
    "Quantum uncertainty suggests your probability wave collapsed... dramatically.",
    "Preliminary data indicates your psychic resonance is approximately zero hertz.",
    "Hypothesis confirmed: You are not currently bending reality with your mind.",
    "Empirical evidence suggests your paranormal probability is statistically negligible.",
    "Your spiritual frequency is currently experiencing significant interference.",
]

export default failMsgs;